import debounce from 'lodash.debounce';
import Masonry from 'masonry-layout';

$ = jQuery;
export default class ArticlesListing {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.wrapper = this.root.querySelector('[data-articles-listing-grid]');
        this.loaderUp = this.root.querySelector(
            '[data-articles-listing-loader-top]'
        );
        this.loader = this.root.querySelector('[data-articles-listing-loader]');
        this.cards = this.root.querySelectorAll('.articles-listing__item');
        this.masonry = null;

        this.html = this.wrapper.innerHTML;
        this.settings = JSON.parse(this.root.getAttribute('data-settings'));
        this.category = parseInt(
            this.root.querySelector('[data-articles-listing-category]').value
        );
        this.taxonomy = this.root.querySelector('[data-articles-listing-taxonomy]').value

        this.url = this.root.querySelector('[data-articles-listing-url]').value;

        this.loadScrollArticles = debounce(this.getScrollArticles, 500);
        this.loadArticles = debounce(this.getArticles, 500);
        this.page = 1;
        this.maxNumPages = this.settings.max_num_pages;
        this.perPage = this.settings.per_page;

        this.observer = null;
        this.scrollMode = 'down';
        this.scrollTop = 0;
        this.loaderTopPage = parseInt(
            this.loaderUp.getAttribute('data-articles-listing-loader-top')
        );

        if (this.settings.init_page && this.settings.init_page > 1) {
            this.page = parseInt(this.settings.init_page);
        }

        return true;
    }

    init() {
        this.scrollHandler();
        this.gridHandler();
        this.setObserver();
        this.onResize();
    }

    scrollHandler() {
        window.addEventListener('scroll', event => this.onScroll(event));
    }

    onScroll() {
        const { scrollY, innerHeight } = window;
        const { offsetTop, offsetHeight } = this.loader;
        const overallScroll = innerHeight + scrollY;
        const elScroll = offsetHeight + offsetTop;

        const loaderUpOffsetTop = this.loaderUp.offsetTop;
        const loaderUpOffsetHeight = this.loaderUp.offsetHeight;
        const loaderUpScroll = loaderUpOffsetHeight + loaderUpOffsetTop;

        if (this.scrollTop > scrollY) this.scrollMode = 'up';
        if (this.scrollTop < scrollY) this.scrollMode = 'down';
        this.scrollTop = scrollY;

        if (
            scrollY <= loaderUpScroll &&
            this.scrollMode === 'up' &&
            this.loaderTopPage > 0
        ) {
            this.loadScrollArticles();
        }

        if (
            overallScroll >= elScroll &&
            this.scrollMode === 'down' &&
            this.page < this.maxNumPages
        ) {
            this.loadScrollArticles();
        }
    }

    onResize() {
        window.addEventListener('resize', this.gridHandler.bind(this));
    }

    gridHandler() {
        const { innerWidth } = window;
        let gutter = innerWidth < 992 ? 16 : 24;

        const sizer = this.wrapper.querySelector('.grid-sizer');
        this.masonry = new Masonry(this.wrapper, {
            columnWidth: sizer,
            itemSelector: '.articles-listing__item',
            gutter,
            percentPosition: true,
            horizontalOrder: true,
        });
    }

    getScrollArticles() {
        if (this.scrollMode === 'up') {
            this.loaderUp.classList.add('loading');
        }

        if (this.scrollMode === 'down') {
            this.page = this.page + 1;
            this.loader.classList.add('loading');
        }

        this.loadArticles();
    }

    getArticles() {
        const formData = new FormData();
        formData.append('action', 'get_articles_ajax');
        formData.append('per_page', this.perPage);

        let paged = this.page;

        if (this.scrollMode === 'up') {
            paged = this.loaderTopPage;
        }
        if (this.scrollMode === 'down') {
            paged = this.page;
        }

        if (this.category) formData.append('category', this.category);

        const url = new URL(this.url);
        const searchParams = {};

        if (this.page && this.page > 0) searchParams.page = this.page;
        let newUrl = this.url;

        if (Object.entries(searchParams).length) {
            const searchParamsStr = new URLSearchParams([
                ...Object.entries(searchParams),
            ]).toString();
            newUrl = `${url}/?${searchParamsStr}`;
        }

        $.ajax({
            type: 'GET',
            url: `${home_url}/wp-json/articles/v1/list`,
            data: {
                page: paged,
                per_page: this.perPage,
                category: this.category,
                taxonomy: this.taxonomy,
            },
            success: function (response) {
                const data = response;
                const { maxNumPages, html } = data;

                this.maxNumPages = parseInt(maxNumPages);

                if (this.scrollMode === 'down') {
                    this.html += html;
                    this.wrapper.innerHTML = this.html;
                }

                if (this.scrollMode === 'up') {
                    this.html = html + this.html;
                    this.wrapper.innerHTML = this.html;
                    this.loaderTopPage = this.loaderTopPage - 1;
                }

                window.history.replaceState(this.url, null, newUrl);
            }.bind(this),
            error: function () {
                this.loader.classList.remove('loading');
                this.loaderUp.classList.remove('loading');
            }.bind(this),
            complete: function () {
                this.loader.classList.remove('loading');
                this.loaderUp.classList.remove('loading');
                this.gridHandler();

                this.unsetObserver();
                this.setObserver();
            }.bind(this),
        });
    }

    setObserver() {
        this.cards = this.root.querySelectorAll('.articles-listing__item');
        if (!this.cards) return;

        const options = {
            root: document,
            rootMargin: '0px',
            threshold: 1.0,
        };

        this.observer = new IntersectionObserver(
            this.onCardIntersect.bind(this),
            options
        );
        this.cards.forEach(card => {
            this.observer.observe(card);
        });
    }

    unsetObserver() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
    }

    onCardIntersect(entries, observer) {
        entries.forEach(entry => {
            const { target, isIntersecting } = entry;
            if (!isIntersecting) return;

            let page = target.getAttribute('data-item-page');
            if (page) {
                page = parseInt(page);
            }

            const url = new URL(this.url);
            const searchParams = {};

            if (page && page > 0) {
                searchParams.page = page;
            }

            let newUrl = this.url;

            if (Object.entries(searchParams).length) {
                const searchParamsStr = new URLSearchParams([
                    ...Object.entries(searchParams),
                ]).toString();
                newUrl = `${url}/?${searchParamsStr}`;
            }

            window.history.replaceState(this.url, null, newUrl);
        });
    }
}

const sections = document.querySelectorAll('[data-articles-listing]');
const initArticlesListing = sections => {
    if (sections) sections.forEach(section => new ArticlesListing(section));
};

initArticlesListing(sections);
